import { stripHtml } from '@/utils';

export default class Topic {
  constructor(obj) {
    this.assetAssociations = obj.assetAssociations;
    this.content = obj.content;
    this.contentSourceId = obj.contentSourceId;
    this.difficultyLowerBound = obj.difficultyLowerBound;
    this.difficultyUpperBound = obj.difficultyUpperBound;
    this.displayAttachmentId = obj.displayAttachmentId;
    this.displayDescription = obj.displayDescription;
    this.displayTitle = obj.displayTitle;
    this.featuredImageId = obj.featuredAttachmentId;
    this.id = obj.id;
    this.order = obj.order;
    this.path = obj.path;
    this.productAssociations = obj.productAssociations;
    this.tags = obj.tags;
    this.title = obj.title;
    this.topicType = obj.topicType;
  }

  get assetDescription() {
    if (this.displayDescription) {
      return stripHtml(this.displayDescription);
    }
  }

  get assetTitle() {
    let title = this.displayTitle || this.title || 'Topic';
    return stripHtml(title);
  }

  get assetType() {
    return 'Topic';
  }

  get categoryIds() {
    return this.productAssociations?.map(pa => pa.categoryId) || [];
  }

  get escapedTitle() {
    return stripHtml(this.title);
  }

  get icon() {
    return 'topics';
  }


  get libraryRoute() {
    return {
      name: 'library#show',
      params: {
        assetType: 'topic',
        assetId: this.id,
      },
    };
  }

  get listRowType() {
    return 'topic-list-row';
  }

  // Better suited as a getter but leaving as a method to be consistent with other asset types
  cardMetadata() {
    const wordCount = this.content?.split(' ').length || 0;
    const timeToRead = Math.round(wordCount / 200) > 0 ? Math.round(wordCount / 120) : 1;
    const timeLabel = timeToRead > 1 ? 'minutes' : 'minute';
    return `Approx. ${timeToRead} ${timeLabel}`;
  }

  completedState(state) {
    return !!state;
  }

  difficultyLabel(store) {
    if (this.difficultyLowerBound) {
      const allLevels = store.getters['difficultyLevels/all'];
      const level = allLevels.find(l => l.difficultyLevel == this.difficultyLowerBound);
      return level?.label;
    }
  }

  state(store) {
    return store.getters['topicStates/topicStates'][this.id];
  }
}
